import { useState, useEffect } from "react";
import axios from "axios";
import { Add, Edit as EditIcon } from "@material-ui/icons";
import { Grid, IconButton } from "@material-ui/core";
import translate from "i18n/translate";
import View from "components/utils/View";
import { SrTable, SrContentHeader, SrContentWrapper } from "components/common";
import useStyles from "./operatorsStyles";
import AddOperators from "./AddOperators";
import EditOperators from "./EditOperators";
import { SrButton } from "../../../common";
import { OPERATOR } from "../../../../constants/api";

const Operators = () => {
  const classes = useStyles();
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState();
  const [addOperators, setAddOperators] = useState(false);
  const [editOperators, setEditOperators] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [, setErr] = useState("");

  const columns = [
    {
      header: "Nombre",
      id: "name",
      isSortable: true,
    },
    {
      header: "Correo electrónico",
      id: "email",
      isSortable: true,
    },
    {
      cell: (user) => (
        <IconButton
          className={classes.editIconBtn}
          onClick={() => {
            setEditOperators(true);
            setEditUser(user);
          }}
        >
          <EditIcon />
        </IconButton>
      ),
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(OPERATOR);
      setOperators(res.data?.result);
    } catch (error) {
      setErr(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!operators?.length) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let operatorsView = (
    <Grid container direction="column" spacing={2}>
      <SrContentHeader
        title={translate("menu.operators")}
        actions={
          <SrButton
            variant="contained"
            onClick={() => setAddOperators(true)}
            startIcon={<Add />}
            color="primary"
          >
            {translate("common.add")}
          </SrButton>
        }
      />

      <SrContentWrapper
        isEmpty={!operators?.length}
        isLoading={loading}
        emptyMessage={translate("operators.noData")}
      >
        <Grid item container spacing={3} direction="column">
          <Grid item container>
            <SrTable
              columns={columns}
              rows={operators}
              loading={loading}
              noDataMessage={translate("operators.noData")}
            />
          </Grid>
        </Grid>
      </SrContentWrapper>
    </Grid>
  );

  if (addOperators) {
    operatorsView = (
      <AddOperators
        onReturn={() => {
          setAddOperators(false);
        }}
        onCreate={(newOperator) => {
          setOperators([...operators, newOperator]);
        }}
      />
    );
  } else if (editOperators) {
    operatorsView = (
      <EditOperators
        onReturn={() => {
          setEditOperators(false);
        }}
        onUpdate={(updatedOperator) => {
          setOperators(
            operators.map((operator) => {
              if (operator.id === updatedOperator.id) {
                return updatedOperator;
              }

              return operator;
            })
          );
        }}
        onDelete={(deletedOperator) => {
          setOperators(
            operators.filter((operator) => operator.id !== deletedOperator.id)
          );
        }}
        user={editUser}
      />
    );
  }

  return <View translateTitleKey="menu.operators">{operatorsView}</View>;
};

export default Operators;
